<script setup>
import { computed, ref } from 'vue';
import { CdrText, CdrSelect } from '@rei/cedar';
import DepartureInfo from './DepartureInfo.vue';
import ReservationDisplay from './ReservationDisplay.vue';
import StepNavigation from './StepNavigation.vue';
import { useCancellationStore } from '../../stores/day-cancellation';
import cms from './data';

const cancellation = useCancellationStore();
const hasSubmitCancellation = ref(false);

const options = [
  'Scheduling Conflict',
  'Got on another REI Experience',
  'Sick/Injured',
  'Personal Emergency',
  'Weather',
  'Changed Mind',
];

const primary = () => {
  hasSubmitCancellation.value = true;
  cancellation.cancelReservation();
};

const secondary = () => {
  cancellation.stepIdx -= 1;
};

const primaryDisabled = computed(
  () => !cancellation.cancellationReason || hasSubmitCancellation.value,
);
</script>

<template>
  <section class="confirm-cancellation">
    <CdrText
      class="confirm-cancellation__title"
      tag="h3"
    >
      {{ cms.confirmCancellation.cancelHeading }}
    </CdrText>
    <DepartureInfo class="confirm-cancellation__departure-info" />
    <CdrText class="confirm-cancellation__for">for</CdrText>
    <ReservationDisplay
      class="confirm-cancellation__reservation-display"
      :reservations="cancellation.reservations.selected"
    />
    <hr class="confirm-cancellation__hr" />
    <div class="confirm-cancellation__select">
      <CdrSelect
        v-model="cancellation.cancellationReason"
        label="Why do you need to cancel?"
        prompt="Select a reason"
        data-ui="confirm-cancellation__cancellation-reason"
        size="large"
        :options="options"
      />
    </div>
    <StepNavigation
      class="confirm-cancellation__step-navigation"
      :primary="cms.confirmCancellation.navigation.primary"
      :primary-disabled="primaryDisabled"
      :secondary="cms.confirmCancellation.navigation.secondary"
      :link="cms.confirmCancellation.navigation.link"
      @primary="primary"
      @secondary="secondary"
    />
  </section>
</template>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.confirm-cancellation {
  max-width: 587px;
  padding-top: $cdr-space-two-x;

  &__title {
    @include cdr-text-body-300;
  }

  &__departure-info {
    padding-top: $cdr-space-half-x;
  }

  &__for {
    padding-top: $cdr-space-two-x;
  }

  &__reservation-display {
    padding-top: $cdr-space-half-x;
  }

  &__hr {
    width: 100%;
    height: 2px;
    margin-top: $cdr-space-two-x;
    margin-bottom: $cdr-space-two-x;
    margin-right: $cdr-space-two-x;
    background-color: $cdr-color-text-secondary;
    border: none;
  }

  &__select {
    width: 100%;
  }

  &__step-navigation {
    padding-top: $cdr-space-two-x;
  }

  @include cdr-sm-mq-up {
    &__select {
      max-width: 343px;
    }
  }
}
</style>
